@if (!(authService.isDoneLoading$ | async) && !shouldSkipLoading()) {
	@if (location === TypePathLocation.Default) {
		<div class="img-loading" id="loading-default">
			<div>
				<img src="/presentation/assets/images/partnerLogo.png" alt="client-portal-loading" width="150" />
				<div class="loadingio-spinner-ellipsis-zslzcgemb2s">
					<div class="ldio-flqcxk9zws6">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			</div>
		</div>
	}
} @else {
	<div [ngClass]="settingsService.currentTheme | async">
		<router-outlet></router-outlet>
		<app-my-swal #mySwalComponent></app-my-swal>
	</div>
}
